import React, { useMemo } from 'react';
import Typography from 'new/elements/Typography';
import { FlowTypeCard } from 'new/elements/flows/FlowTypeCard';
import { FlowType } from 'new/elements/flows/types';
import { flowDataMapItems } from 'new/elements/flows/dataMap';
import { useFlowTypesVisibility } from 'new/hooks/useFlowTypeVisibility';

import classes from './FlowTypeSelection.module.scss';
import { FLOW_CATEGORY } from 'new/components/flows/types/flowTypes';

interface FlowTypeSelectionProps {
  selected?: FlowType;
  onFlowSelected?: (type: FlowType) => void;
  handleOnClickNew(a: FlowType): void;
}

export const FlowTypeSelection = (props: FlowTypeSelectionProps) => {
  // Get all flow types from the category
  const allFlowTypes = flowDataMapItems[FLOW_CATEGORY.flow_types] as FlowType[];

  // Get visibility for all flow types at once
  const flowTypesVisibility = useFlowTypesVisibility(allFlowTypes);

  // Filter to only show enabled flow types
  const availableFlowTypes = useMemo(() => {
    return allFlowTypes.filter((flowType: FlowType) => {
      return flowTypesVisibility[flowType]?.isEnabled ?? false;
    });
  }, [allFlowTypes, flowTypesVisibility]);

  return (
    <div className={classes.flowsContainer}>
      <div className={classes.flowsCards}>
        {availableFlowTypes.map((flowType: FlowType) => {
          const isSelected = props.selected === flowType;
          const visibility = flowTypesVisibility[flowType];
          const isEnabled = visibility?.isEnabled ?? false;

          return (
            <FlowTypeCard
              key={flowType}
              type={flowType}
              selected={isSelected}
              onFlowSelected={props.onFlowSelected}
              handleOnClickNew={() => props.handleOnClickNew(flowType)}
              isEnabled={isEnabled}
            />
          );
        })}
      </div>
    </div>
  );
};
